import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(34 34)">
      <g fillRule="nonzero">
        <path
          d="m13.5264972 62.4297955c-.7037796-.7037796-1.8439025-.7037796-2.5476821 0s-.7037796 1.8439025 0 2.5476821l6.0437072 6.0437072c.3518898.3518898.8128654.5278348 1.2738411.5278348s.9219513-.175945 1.2738411-.5278348c.7037796-.7037796.7037796-1.8439025 0-2.5476821z"
          fill="#7bb835"
          transform="matrix(-1 0 0 1 30.54902 0)"
        />
        <path
          d="m15.9382619 72.0768543c-.7037796-.7037796-1.8439025-.7037796-2.5476821 0s-.7037796 1.8439025 0 2.5476821l6.0437072 6.0437072c.3518898.3518898.8128654.5278348 1.2738411.5278348s.9219513-.175945 1.2738411-.5278348c.7037796-.7037795.7037796-1.8439025 0-2.5476821z"
          fill="#15539f"
          transform="matrix(-1 0 0 1 35.37255 0)"
        />
        <path
          d="m3.87943834 60.0180308c-.70377958-.7037796-1.8439025-.7037796-2.54768208 0-.70377959.7037796-.70377959 1.8439025 0 2.5476821l6.04370718 6.0437072c.35188979.3518898.81286546.5278348 1.27384113.5278348s.92195134-.175945 1.27384114-.5278348c.70377959-.7037796.70377959-1.8439025 0-2.5476821z"
          fill="#53a2d9"
          transform="matrix(-1 0 0 1 11.254902 0)"
        />
        <path
          d="m27.9112758 44.7682899c-9.0769238-16.3959004-18.34883396-19.8467213-24.51827695-19.8467213-1.24652698 0-2.38279264.141979-3.39299885.3548929 4.45871441 5.7820701 8.07061306 12.3051375 10.5987256 19.4163099 1.1175461-.5619138 2.4209892-.8542749 3.9453878-.8542749 5.2298949 0 10.867508 3.3078596 10.9206368 3.3435453.6914328.4113135 1.5601064.304038 2.1451734-.2502365.5673212-.5721719.6914328-1.4482728.3013522-2.1635154z"
          stroke="#51565c"
          strokeWidth="3.5"
          transform="matrix(-1 0 0 1 28.137254 0)"
        />
        <path
          d="m54.646401 65.6904657c.1259673-.4410292.2997453-.8450536.494045-1.2342543-7.1100566-2.5274784-13.632739-6.1366471-19.4142447-10.5934663-.4149061 1.9771657-.5568103 4.4402643.0879805 7.2539357 1.7348337 7.5342857 8.2625373 14.483526 19.4045296 20.65285.286101.159489.572311.2304692.8763135.2304692.4650093 0 .9300184-.1950873 1.2876171-.5319184.5544089-.5849373.6617103-1.4535788.2504063-2.1449862-1.3055188-2.1805847-4.381675-8.8638657-2.9866473-13.6326297z"
          stroke="#51565c"
          strokeWidth="3.5"
          transform="matrix(-1 0 0 1 93.254902 0)"
        />
        <path
          d="m81.9324109 49.2640111c-7.7267527-29.0090638-34.0965777-49.2640111-64.0818074-49.2640111-.9746731 0-1.7721721.7973529-1.7721721 1.77208751 0 29.98369029 20.2559143 56.35236109 49.2663632 64.07863659.1418041.0532146.3013471.0708445.4607821.0708445.4607822 0 .9038252-.1771655 1.2405421-.5316046l14.4255105-14.4248182c.4607816-.4430219.6379555-1.0986856.4607816-1.7011347z"
          stroke="#51565c"
          strokeWidth="3.5"
          transform="matrix(-1 0 0 1 98.078432 0)"
        />
      </g>
      <path
        d="m65.7376622 28.7536043c-1.6688468 1.6685367-3.8823953 2.5993369-6.2541007 2.5993369-2.3540131 0-4.5851468-.9308002-6.2541007-2.5993369-3.4432026-3.4424491-3.4432026-9.0627324 0-12.5050741 1.6689539-1.6685367 3.9000874-2.5818635 6.2541007-2.5818635 2.3717052 0 4.5852539.9133268 6.2541007 2.5818635 3.4608948 3.4423417 3.4608948 9.062625 0 12.5050741z"
        fill="#51565c"
      />
    </g>
  </Svg>
)
